// Mock data for AuraPrintiqo website

export const BRAND = {
  name: "AuraPrintiqo",
  tagline: "Turn Your Moments Into Unforgettable Creations, Crafted Just for You",
  subtagline: "Beautifully crafted custom designs for pets, couples, and more — printed on premium T-shirts, hoodies, mugs, and other high-quality products made to last.",
  instagram: "https://www.instagram.com/aura_printiqo/",
  whatsapp: "918889616972", // To be updated
  googleForm: "#", // To be updated
  email: "hello@auraprintiqo.com"
};

export const IMAGES = {
  // Hero image
  hero: "/images/hero-all.png",

  // Product mockups
  tshirtWhite: "/images/self-cover.jpg",
  tshirtFlat: "/images/self-after.png",
  hoodieYellow: "/images/couple-cover.png",
  hoodieWhite: "/images/pet-after.png",
  hoodiePerson: "/images/couple-after.png",
  corporateTshirt: "/images/corporate-cover.png",

  // Pet collection images
  petTshirt: "/images/pet-cover.png",
  petPhoto: "/images/pet-before.png",
  petAnimeArt: "/images/pet-after.png",

  // Couple collection images
  couplePhoto: "/images/couple-before.png",
  coupleArt: "/images/couple-after.png",
  coupleHoodie: "/images/couple-cover.png",

  // Corporate images
  corporateTeam: "/images/corporate-cover.png",
  corporateDesign: "/images/corporate-after.png"
};

export const USP_CARDS = [
  {
    id: 1,
    icon: "Sparkles",
    title: "AI-Generated Custom Art",
    description: "Your photos transformed into stunning anime-style artwork using cutting-edge AI technology"
  },
  {
    id: 2,
    icon: "Award",
    title: "Premium Quality Prints",
    description: "High-quality fabric and printing that lasts wash after wash"
  },
  {
    id: 3,
    icon: "Package",
    title: "Made to Order",
    description: "Each piece is uniquely crafted and delivered straight to your door"
  }
];

export const HOW_IT_WORKS_STEPS = [
  {
    id: 1,
    icon: "Upload",
    title: "Upload Photo",
    description: "Send us your favorite photo via Instagram or WhatsApp"
  },
  {
    id: 2,
    icon: "Wand2",
    title: "AI Creates Artwork",
    description: "Our AI transforms your photo into beautiful anime-style art"
  },
  {
    id: 3,
    icon: "CheckCircle",
    title: "You Approve",
    description: "Review and approve your custom design before printing"
  },
  {
    id: 4,
    icon: "Truck",
    title: "We Ship",
    description: "Your custom print is created and delivered to you"
  }
];

export const COLLECTIONS = [
  {
    id: "pet-anime",
    title: "Pet Anime Collection",
    shortDescription: "Turn your furry friends into adorable anime characters on premium apparel",
    description: "Transform your beloved pets into stunning anime-style artwork. Perfect for pet lovers who want to celebrate their furry companions in a unique and artistic way.",
    image: "/images/pet-cover.png",
    products: ["T-Shirt", "Hoodie"],
    priceRange: "₹799 - ₹1,499",
    beforeImage: "/images/pet-before.png",
    afterImage: "/images/pet-after.png",
    finalImage: "/images/pet-after-2.webp"
  },
  {
    id: "couple-anime",
    title: "Couple Anime Collection",
    shortDescription: "Celebrate your love in beautiful Ghibli-inspired style hoodies & tees",
    description: "Create magical memories with your partner through beautiful anime and Ghibli-inspired artwork. Perfect for anniversaries, gifts, or just because.",
    image: "/images/couple-cover.png",
    products: ["T-Shirt", "Hoodie", "Matching Set"],
    priceRange: "₹899 - ₹2,499",
    beforeImage: "/images/couple-before.png",
    afterImage: "/images/couple-after.png",
    finalImage: "/images/couple-cover.png"
  },
  {
    id: "corporate-custom",
    title: "Corporate Custom Collection",
    shortDescription: "Professional bulk orders with tech themes & motivational designs for teams",
    description: "Custom designed merchandise for your team, company events, or brand promotion. Choose from tech-inspired designs, motivational quotes, or trending phrases. Bulk pricing available.",
    image: "/images/corporate-cover.png",
    products: ["T-Shirt", "Hoodie", "Polo"],
    priceRange: "Contact for Quote",
    beforeImage: "/images/corporate-before.png",
    afterImage: "/images/corporate-after.png",
    finalImage: "/images/corporate-cover.png"
  },
  {
    id: "self-custom",
    title: "Self / Custom Collection",
    shortDescription: "Your vision, our craft. From AI portraits to bespoke streetwear designs.",
    description: "The ultimate creative freedom. Upload your photo for AI anime transformation, commission custom digital artwork, bring your own design, or collaborate with our artists on typography and streetwear aesthetics. Every piece is a limited edition of one.",
    image: "/images/self-cover.jpg",
    products: ["Premium T-Shirt", "Oversized Tee", "Hoodie", "Sweatshirt"],
    priceRange: "₹999 - ₹2,999",
    beforeImage: "/images/self-before.png",
    afterImage: "/images/self-after.png",
    finalImage: "/images/self-cover.jpg",
    customizationTypes: [
      {
        id: "anime-transform",
        title: "AI Anime Portrait",
        description: "Transform your photo into stunning anime-style artwork",
        icon: "Sparkles",
        startingPrice: "₹999"
      },
      {
        id: "creative-illustration",
        title: "Creative Illustration",
        description: "Bespoke digital artwork crafted by our artists",
        icon: "Palette",
        startingPrice: "₹1,499"
      },
      {
        id: "own-design",
        title: "Your Design",
        description: "Upload your print-ready artwork for production",
        icon: "Upload",
        startingPrice: "₹799"
      },
      {
        id: "typography-streetwear",
        title: "Typography & Streetwear",
        description: "Custom text-based and urban aesthetic designs",
        icon: "Type",
        startingPrice: "₹1,299"
      }
    ]
  }
];

// Placeholder for user's own collections - to be populated later
export const MY_COLLECTIONS = [];

export const PRODUCT_OPTIONS = {
  tshirt: {
    name: "Premium T-Shirt",
    fabric: "100% Combed Cotton, 180 GSM",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["White", "Black", "Navy", "Grey"],
    delivery: "5-7 business days"
  },
  hoodie: {
    name: "Premium Hoodie",
    fabric: "Cotton Fleece Blend, 320 GSM",
    sizes: ["S", "M", "L", "XL", "XXL"],
    colors: ["White", "Black", "Grey"],
    delivery: "7-10 business days"
  }
};

export const REVIEWS = [
  {
    id: 1,
    name: "Priya S.",
    avatar: "PS",
    rating: 5,
    text: "Got my cat's anime portrait on a hoodie and I'm obsessed! The quality is amazing and the artwork captured her personality perfectly.",
    product: "Pet Anime Hoodie"
  },
  {
    id: 2,
    name: "Rahul M.",
    avatar: "RM",
    rating: 5,
    text: "Ordered matching Ghibli-style hoodies for our anniversary. My girlfriend loved it! Will definitely order again.",
    product: "Couple Anime Set"
  },
  {
    id: 3,
    name: "Sneha K.",
    avatar: "SK",
    rating: 5,
    text: "The team was super helpful and the final print exceeded my expectations. Great communication throughout!",
    product: "Pet Anime T-Shirt"
  },
  {
    id: 4,
    name: "Arjun P.",
    avatar: "AP",
    rating: 5,
    text: "Ordered 50 custom tees for our startup team. Everyone loved them! Professional service and great bulk pricing.",
    product: "Corporate Order"
  }
];

export const FAQS = [
  {
    question: "Can I request changes to my artwork?",
    answer: "Absolutely! We share a preview of your AI-generated artwork before printing. You can request up to 2 revisions to ensure you're completely happy with the design."
  },
  {
    question: "How long does delivery take?",
    answer: "T-shirts are delivered within 5-7 business days, and hoodies within 7-10 business days after artwork approval. We ship pan-India!"
  },
  {
    question: "Is payment prepaid or COD available?",
    answer: "We currently accept prepaid orders via UPI, cards, and net banking. COD is available for orders above ₹1,500 with a small additional fee."
  },
  {
    question: "What photo quality do you need?",
    answer: "For best results, send us a clear, well-lit photo. Front-facing photos work best for portraits. We'll let you know if we need a different angle!"
  },
  {
    question: "Do you offer bulk discounts?",
    answer: "Yes! For orders of 10+ items, we offer special bulk pricing. Contact us via WhatsApp or Instagram for a custom quote."
  }
];

export const SIZE_CHART = {
  tshirt: [
    { size: "S",   chest: "36", length: "26" },
    { size: "M",   chest: "38", length: "27" },
    { size: "L",   chest: "40", length: "28" },
    { size: "XL",  chest: "42", length: "29" },
    { size: "XXL", chest: "44", length: "30" }
  ],
  hoodie: [
    { size: "S",   chest: "38", length: "25" },
    { size: "M",   chest: "40", length: "26" },
    { size: "L",   chest: "42", length: "27" },
    { size: "XL",  chest: "44", length: "28" },
    { size: "XXL", chest: "46", length: "29" }
  ]
};
